import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../store';

export function RegisterForm() {
  const { t } = useTranslation();
  const email = useAuth(s => s.email);
  const name = useAuth(s => s.name);
  const password = useAuth(s => s.password);
  const confirmPassword = useAuth(s => s.confirmPassword);
  const authLoading = useAuth(s => s.authLoading);
  const authError = useAuth(s => s.authError);
  const setEmail = useAuth(s => s.setEmail);
  const setName = useAuth(s => s.setName);
  const setPassword = useAuth(s => s.setPassword);
  const setConfirmPassword = useAuth(s => s.setConfirmPassword);
  const setAuthView = useAuth(s => s.setAuthView);
  const resetAuthForm = useAuth(s => s.resetAuthForm);
  const handleRegister = useAuth(s => s.handleRegister);

  const onSubmit = (e: React.FormEvent) => { e.preventDefault(); handleRegister(); };

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <p className="text-sm font-medium text-gray-700">{t('storeSettings.register')}</p>
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder={t('storeSettings.name')}
        required
        autoComplete="name"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <input
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder={t('storeSettings.email')}
        required
        autoComplete="email"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <input
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        placeholder={t('storeSettings.password')}
        required
        autoComplete="new-password"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <input
        type="password"
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        placeholder={t('storeSettings.confirmPassword')}
        required
        autoComplete="new-password"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {authError && <p className="text-sm text-red-600">{authError}</p>}
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={authLoading || !email.trim() || !name.trim() || !password || !confirmPassword}
          className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {authLoading ? t('storeSettings.registering') : t('storeSettings.register')}
        </button>
        <button
          type="button"
          onClick={() => { setAuthView(null); resetAuthForm(); }}
          className="rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50"
        >
          {t('common.cancel')}
        </button>
      </div>
      <div className="text-xs text-center">
        <button
          type="button"
          onClick={() => { setAuthView('login'); resetAuthForm(); }}
          className="text-blue-600 hover:underline"
        >
          {t('storeSettings.backToLogin')}
        </button>
      </div>
    </form>
  );
}
